import React, { useState, useEffect, Fragment } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  Home as HomeIcon,
  FlashOn as FlashOnIcon,
  ArrowBack as ArrowBackIcon,
  DateRange as DateRangeIcon,
  Face as FaceIcon,
  Power as PowerIcon,
  //TrendingFlat as TrendingFlatIcon,
  AccountCircle as AccountCircleIcon,
  Assessment as AssessmentIcon,
  Build as BuildIcon,
  Timeline as TimelineIcon,
  Receipt as ReceiptIcon,
  Notifications as NotificationsIcon
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import config from '../../config';


// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
//import Dot from "./components/Dot";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";

const structure = [
  { id: 0, label: "Dashboard", link: "/app/dashboard", icon: <HomeIcon /> },
  {
    id: 1,
    label: "Customers",
    link: "/app/customers",
    icon: <FaceIcon />,
  },
  {
    id: 2,
    label: "Jobs",
    link: "/app/jobss",
    icon: <FlashOnIcon />,
    children: [
        {
            label: 'Open Jobs',
            link: '/app/jobs',
            short: 'Open'
        },
        {
            label: 'Closed Jobs',
            link: '/app/closed',
            short: 'Close'
        },

    ]
  },
  {
    id: 3,
    label: "Retests",
    link: "/app/retests",
    icon: <DateRangeIcon />,
  },
  {
    id: 4,
    label: "Retest Reminders",
    link: "/app/retest-emails",
    icon: <NotificationsIcon />,
  },
  {
    id: 5,
    label: "Assets",
    link: "/app/assets",
    icon: <PowerIcon />,
  },
  {
    id: 6,
    label: "Accounts",
    link: "/app/accounts",
    icon: <AccountCircleIcon />,
  },
  /*{
    id: 6,
    label: "Correct Job Numbers",
    link: `${config.clientApi}/jobfix.jsp`,
    icon: <TrendingFlatIcon />,
    isExternal: true
  },*/
  {
    id: 7,
    label: "Reports",
    link: "/app/reports",
    icon: <AssessmentIcon />,
  },
  { id: 8, label: "Insights", link: "/app/insights", icon: <TimelineIcon /> },
  { id: 9, label: "Refunds", link: "/app/refunds", icon: <ReceiptIcon /> },
  {
    id: 10,
    label: "Tools",
    link: "/app/tools",
    icon: <BuildIcon />,
    children: [
        {
          label: "Correct Job Number",
          link: `${config.clientApi}/jobfix.jsp`,
          short: 'Correct Job No.',
          isExternal: true
        },
        {
          label: "Timesheet System",
          link: `${config.clientApi}/my-timesheet`,
          short: 'Timesheet',
          isExternal: true
        },
        {
          label: "Legacy Reports",
          link: `${config.clientApi}`,
          short: 'Legacy Reports',
          isExternal: true
        },
        {
          label: "Upload Metrel Results",
          link: "/app/upload",
          short: 'Upload Metrel',
          isExternal: false
        },
        {
          label: "Upload Metrel Tests",
          link: "/app/metrel_upload_custom_tests",
          short: 'Upload MC Tests',
          isExternal: false
        },
        {
          label: "Update CPI",
          link: "/app/cpi",
          short: 'Update CPI',
          isExternal: false
        },
    ]
  },

];

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);
  const adminRoles = JSON.parse(localStorage.getItem("admin_roles"));
  const insightsRole = adminRoles?.includes("INSIGHTS");

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <Fragment key={link.id}>
            {(link.id !== 8 || insightsRole) && (
              <SidebarLink
                key={link.id}
                location={location}
                isSidebarOpened={isSidebarOpened}
                {...link}
                />
            )}
          </Fragment>
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
